import { createAsyncThunk } from '@reduxjs/toolkit';

import { VendorsResponseSchema } from '../types/VendorsSchema';

import type { ThunkConfig } from 'app/providers/StoreProvider/config/types';

export const deleteVendorFromProperty = createAsyncThunk<
    VendorsResponseSchema,
    { vendorId: string; propertyId: string },
    ThunkConfig<string>
>(
    'vendors/deleteVendorFromProperty',
    async ({ propertyId, vendorId }, thunkApi) => {
        const { extra, rejectWithValue } = thunkApi;

        try {
            const response = await extra.api.delete(
                `/v1/properties/${propertyId}/vendors`,
                { data: { vendorId } },
            );

            return response.data;
        } catch (e) {
            return rejectWithValue('error');
        }
    },
);
